import { riveEmbed } from '../../assets/scripts/rive-embed';
riveEmbed();
